import dev from './dev-env-config';
import prod from './prod-env-config';
import dev_atom from './dev-env-atompoint-config';

export default APP_ENV === 'dev' ? dev : APP_ENV ===  'dev-atom' ? dev_atom : prod;
